import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "page-container" };
const _hoisted_2 = { class: "grid" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "one-desk-table-header-group" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "No records found")
], -1);
import { computed, ref, watch } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import OneDeskCard from "@/components/molecules/OneDeskCard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskTable',
    props: {
        loading: { type: Boolean },
        title: { default: "" },
        tableData: { default: () => [] },
        columnsDefinition: { default: () => [] },
        hasPagination: { type: Boolean, default: false },
        hasFilters: { type: Boolean, default: false },
        groupedValue: { default: "brand" },
        globalFilterFields: {},
        filters: {},
        onRowClick: {},
        pageIndex: { default: 1 },
        pageSize: { default: 10 },
        totalRecords: { default: 0 },
        isRowSelectable: { type: Boolean },
        hasMenu: { type: Boolean, default: false },
        menuItems: { default: () => [] },
        lazy: { type: Boolean, default: true }
    },
    emits: ["page-change", "search-change", "clear-filters"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const onRowClick = (event) => {
            if (props.onRowClick)
                props.onRowClick(event.data);
        };
        const clearFilters = () => {
            emit("clear-filters");
        };
        const hasGroupedRows = computed(() => {
            return props.groupedValue && props.groupedValue != "";
        });
        const firstRecordIndex = ref(0);
        const loading = ref(false);
        watch(() => props.groupedValue, () => {
            loading.value = true;
            setTimeout(() => (loading.value = false), 1);
        });
        const onFilterApply = (event) => {
            elementCount.value = event.filteredValue.length;
        };
        const elementCount = ref(props.tableData.length);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(OneDeskCard, {
                            title: _ctx.title,
                            "has-search": true,
                            "has-filters": _ctx.hasFilters,
                            "has-menu": _ctx.hasMenu,
                            "menu-items": _ctx.menuItems,
                            "onUpdate:searchText": _cache[1] || (_cache[1] = ($event) => (emit('search-change', $event))),
                            onClearFilters: clearFilters
                        }, _createSlots({
                            content: _withCtx(() => [
                                (!loading.value)
                                    ? (_openBlock(), _createBlock(_unref(DataTable), {
                                        key: 0,
                                        value: _ctx.tableData,
                                        paginator: _ctx.hasPagination && _ctx.totalRecords > _ctx.pageSize,
                                        page: firstRecordIndex.value,
                                        onFilter: onFilterApply,
                                        rows: _ctx.pageSize,
                                        lazy: _ctx.lazy,
                                        "removable-sort": "",
                                        "responsive-layout": "scroll",
                                        totalRecords: props.totalRecords,
                                        first: (_ctx.pageIndex - 1) * _ctx.pageSize,
                                        "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                        onRowClick: onRowClick,
                                        currentPageReportTemplate: "{first} to {last} of {totalRecords}",
                                        onPage: _cache[0] || (_cache[0] = ($event) => emit('page-change', $event.page)),
                                        "row-class": () => 'one-desk-table-row'
                                    }, _createSlots({
                                        empty: _withCtx(() => [
                                            _hoisted_5
                                        ]),
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsDefinition, (item) => {
                                                return (_openBlock(), _createBlock(_unref(Column), {
                                                    "header-class": 'one-desk-table-header ' + props.headerClass,
                                                    key: item.field,
                                                    field: item.field,
                                                    header: item.header
                                                }, _createSlots({ _: 2 }, [
                                                    (item.hasSlot)
                                                        ? {
                                                            name: "body",
                                                            fn: _withCtx((slotProps) => [
                                                                _renderSlot(_ctx.$slots, item.field, {
                                                                    item: slotProps.data
                                                                })
                                                            ]),
                                                            key: "0"
                                                        }
                                                        : undefined
                                                ]), 1032, ["header-class", "field", "header"]));
                                            }), 128))
                                        ]),
                                        _: 2
                                    }, [
                                        (hasGroupedRows.value)
                                            ? {
                                                name: "groupheader",
                                                fn: _withCtx((slotProps) => [
                                                    _createElementVNode("span", _hoisted_4, _toDisplayString(slotProps.data[_ctx.groupedValue]), 1)
                                                ]),
                                                key: "0"
                                            }
                                            : undefined
                                    ]), 1032, ["value", "paginator", "page", "rows", "lazy", "totalRecords", "first"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 2
                        }, [
                            (_ctx.hasFilters)
                                ? {
                                    name: "filters",
                                    fn: _withCtx(() => [
                                        _renderSlot(_ctx.$slots, "filters")
                                    ]),
                                    key: "0"
                                }
                                : undefined
                        ]), 1032, ["title", "has-filters", "has-menu", "menu-items"])
                    ])
                ])
            ]));
        };
    }
});
